// @flow
// @jsx h
import { h, Component } from "preact";
import { Text, IntlProvider } from "preact-i18n";

import styles from "./FormInput.scss";

import { withStyles } from "elc-theme";
import { GlassIcon } from "elc-icons";
import SwitchInput from "./SwitchInput";
import InputError from "./InputError";
//liste ds pays
import { COUNTRIES } from "elc-commons";

import { CommunesAjax } from "./CommunesAjax";

import { en, fr, de, nl, it, es, ca } from "./translations";

import debounce from 'lodash.debounce';


class AutocompleteAddress extends Component {

  constructor(props) {
    super(props);

      const locale = props.locale === "en" ? "gb" : (props.locale || "fr");
      const codePays = locale; 

    this.state = {
      address: props.value
        ? {
            street_number: "_",
            route: this.formatStreet(props.value),
            locality: props.value.locality  || props.value.city,
            country: props.value.country,
            postal_code:  props.value.postal_code || props.value.zipCode,
            code_pays: props.value.code_pays || (props.value.country !== null && props.value.country !== undefined ? this.findBestCountryMatch(props.value.country, COUNTRIES).country.code : 'fr')
          }
        : {
            street_number: "_",
            route: "",
            locality: "",
            // administrative_area_level_1: '',
            country: this.getCountryNameByCode(codePays, props.locale),
            postal_code: "",
            code_pays: locale
          },
      visible:
        props.clientFormField.mandatory || props.isClientInformationMandatory
          ? true
          : false,
      error : props.error
    };

 // on bind la fonction debounce une seule fois
    this.debouncedSearch = debounce(this.onDebouncedChange, 300);
  }

  //
normalize(str) {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

levenshtein(a, b) {
  const matrix = [];

  for (let i = 0; i <= b.length; i++) matrix[i] = [i];
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b[i - 1] === a[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[b.length][a.length];
}

findBestCountryMatch(search, countries) {
  if (!search || !countries.length) return null;

  const normalizedSearch = this.normalize(search);

  //  1. match EXACT sur code pays (ultra important)
  const exactCode = countries.find(
    c => c.code.toLowerCase() === normalizedSearch
  );
  if (exactCode) {
    return { country: exactCode, score: 0, matchedLang: 'code' };
  }

  // 2. match direct dans les noms (includes)
  for (const country of countries) {
    for (const [lang, value] of Object.entries(country.name)) {
      if (this.normalize(value).includes(normalizedSearch)) {
        return { country, score: 0, matchedLang: lang };
      }
    }
  }

  // 3. fallback Levenshtein
  let bestMatch = null;
  let bestScore = Infinity;
  let bestLang = null;

  for (const country of countries) {
    for (const [lang, value] of Object.entries(country.name)) {
      const normalizedValue = this.normalize(value);
      const score = this.levenshtein(normalizedSearch, normalizedValue);

      if (score < bestScore) {
        bestScore = score;
        bestMatch = country;
        bestLang = lang;
      }
    }
  }

  // 4. seuil de pertinence (TRÈS important)
  const maxAllowed = Math.max(2, normalizedSearch.length * 0.4);

  if (bestScore > maxAllowed) {
    //return null; // rien de pertinent
      return {
      country: countries.find(c => c.code === 'fr'),
      score: null,
      matchedLang: 'fallback'
    };
  }

  return { country: bestMatch, score: bestScore, matchedLang: bestLang };
}

  //format l objet adresse 
  formatStreet(value) {
    if (!value) return "";

    const clean = v => {
      if (!v) return "";
      const str = v.toString().trim();
      return str === "_" ? "" : str;
    };

    const streetNumber =  clean(value.street_number || value.address1);
    const route = clean(value.route || value.address2);

    return [streetNumber, route].filter(Boolean).join(" ");
  }

  getCountryNameByCode(code, locale) {

    const country = COUNTRIES.find(c => c.code === code);
    if (!country) return null;

    return country.name[locale] ?? country.name["fr"];
  }


  child: CommunesAjax | null = null;

  setChildRef = (ref: CommunesAjax | null) => {
      this.child = ref;
  };


  onDebouncedChange = (value) => {
             this.child.loadData(value);
  };

  
  onChange = (e) => {
    const { id, value: rawValue } = e.target;

    this.setState(
      (prev) => {
        // Copie immuable de l’adresse
        const address = { ...prev.address };

        if (id === "country") {
          // 1) Met à jour le code pays (code ISO, ex: "FR")
          address.code_pays = rawValue;

          // 2) (Optionnel) Si tu as un champ "country" textuel, pose aussi le label selon la locale
          const found = COUNTRIES.find((c) => c.code === rawValue);
          const countryLabel = found ? found.name[this.props.locale] || found.name["fr"] || found.code : rawValue;

          // Si tu veux garder un champ "country" label :
          address.country = countryLabel;

          // 3) Si on quitte la France, on nettoie les champs dépendants
          if (rawValue.toUpperCase() !== "FR") {
            //   address.postal_code = "";
            address.locality = "";
          }

          // 4) Si on passe à FR et qu’un CP est présent, on pourra relancer la recherche communes en callback
          return { address };
        }

        // Pour tous les autres champs (postal_code, locality, etc.)
        address[id] = rawValue.replace(/,/g, '');
        return { address };
      },
      () => {
        // === Callback post-setState ===

        // 1) Toujours prévenir le parent avec la dernière version
        if (typeof this.props.onAddressChange === "function") {
          this.props.onAddressChange(this.state.address);
        }

        // 2) Si le CP change et le pays est FR, lancer la recherche côté enfant
        if (id === "postal_code" && this.state.address.code_pays && this.state.address.code_pays.toUpperCase() === "FR" && this.child && typeof this.child.loadData === "function") {
           this.debouncedSearch(this.state.address.postal_code);
        }

        // 3) Si le pays vient d’être changé vers FR et qu’on a déjà un CP → recharger CommunesAjax
        if (id === "country" && rawValue.toUpperCase() === "FR" && this.state.address.postal_code && this.child && typeof this.child.loadData === "function") {
          this.child.loadData(this.state.address.postal_code);
        }
      },
    );
  };


  // onBlur = ({ target }) => {
  //   if(this.props.onAddressBlur){
  //       let value = target.value;

  //       this.setState(prevState => {
          
  //       if(target.id === "country"){
  //           const codePays = target.value;
  //           const paysLabel = COUNTRIES.find((country) => country.code === codePays);
  //           value = paysLabel?.name[this.props.locale]
  //           prevState.address.code_pays = target.value;
  //       }

  //         prevState.address[target.id] = value;

  //         this.props.onAddressBlur(prevState.address);
  //         return { address: prevState.address };
  //       });
  //   }
  // };


  isMandatory = () =>
    this.props.clientFormField.mandatory ||
    this.props.isClientInformationMandatory
      ? true
      : false;

  componentDidMount() {
        if (this.state.address.postal_code && this.state.address.postal_code !== '' && this.child && typeof this.child.loadData === "function") {
          const locality = (this.state.address.locality && this.state.address.locality !== '') ? this.state.address.locality : '';
          this.child.loadData(this.state.address.postal_code, locality);

        }

      this.props.onAddressChange(this.state.address);
  }

componentDidUpdate(prevProps) {
  if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
    this.setState({ address: this.props.value });
  } 

      if (prevProps.locale !== this.props.locale && (this.props.value.street_number == '' && this.props.value.route == ''&& this.props.value.postal_code == '' && this.props.value.locality == '') ) {
        const locale = this.props.locale === "en" ? "gb" : (this.props.locale || "fr");
        const codePays = locale; 
        this.setState(prevState => ({
            address: {
              ...prevState.address,
              country: this.getCountryNameByCode(codePays, this.props.locale),
              code_pays: locale
            }
          }));
      }

    

  if (prevProps.error !== this.props.error) {
    this.setState({ error: this.props.error });
  }






}


  onToggleAddressVisibility = () => {
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  };

    componentWillUnmount() {
    // important pour éviter des appels après un unmount
    this.debouncedSearch.cancel();
  }
  /* eslint-disable */
  render(
    { clientFormField, getClassName, locale },
    { address, visible ,error},
    context
  ) {
  let localeDefinition = "";

  switch (locale) {
    case "fr":
      localeDefinition = fr;
      break;
    case "en":
      localeDefinition = en;
      break;
    case "de":
      localeDefinition = de;
      break;
    case "nl":
      localeDefinition = nl;
      break;
    case "it":
      localeDefinition = it;
      break;
    case "es":
      localeDefinition = es;
      break;
    case "ca":
      localeDefinition = ca;
      break;
    default:
      localeDefinition = fr;
  }
    return (
      <IntlProvider definition={localeDefinition}>
      <div>
        <div
          key={clientFormField.id}
          class={getClassName("inputField", "inputFieldCheckbox")}
        >
          <div class={getClassName("switchInput")}>
            {!this.isMandatory() && (
              <SwitchInput
                name={clientFormField._embedded.clientFormInputType.label}
                id={clientFormField.id}
                value={visible ? "1" : "0"}
                onChange={this.onToggleAddressVisibility}
              />
            )}
            <label class={getClassName("label")} htmlFor={clientFormField.id}>
              {clientFormField._embedded.clientFormInputType.label}              
              {this.isMandatory() && (
                <span class={getClassName("requiredSign")}>*</span>
              )}{" "}
            </label>
          </div>
        </div>
        <div
          class={getClassName("autoCompleteAddressFields", {
            invisible: !visible
          })}
        >         
          <div>
            <div class={getClassName("inputField", "column")}>
              {/* <div
                class={
                  context.theme && context.theme.label
                    ? context.theme.label
                    : styles.label
                }
              >
                <Text id="address.streetAddress">Street address</Text>
                {this.isMandatory() && (
                  <span class={getClassName("requiredSign")}>*</span>
                )}
              </div> */}
              <div class={styles.row}>
                {/* <div class={styles.streetNumber}>
                  <input
                    class={styles.input}
                    id="street_number"
                    value={address.street_number}
                    placeholder="N°"
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                  />
                </div> */}
                <div>
                  <input
                    class={styles.input}
                    id="route"
                    value={address.route}
                    placeholder="rue, lieu-dit"
                    autoComplete="street-address"
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    type="text"
                  />
                </div>
              </div>
              {error &&
                (error.fields.includes("route") || error.fields.includes("street_number")) && (
                  <div class={styles.row}>
                    <InputError error={error} />
                  </div>
                )}
            </div>
            <div class={styles.row}>
              <div class={getClassName("inputField", "column", "zipCode")}>
                <div
                  class={
                    context.theme && context.theme.label
                      ? context.theme.label
                      : styles.label
                  }
                >
                  <Text id="address.zipCode">Zip code</Text>
                  {this.isMandatory() && (
                    <span class={getClassName("requiredSign")}>*</span>
                  )}
                </div>
                <div class={styles.column} style="width:100%">
                  <input
                    class={styles.input}
                    id="postal_code"
                    value={address.postal_code}
                    autoComplete="postal-code"
                    onChange={this.onChange}
                    type="text"
                    //onBlur={this.onBlur}
                  />
                  {error &&
                    error.fields.includes("postal_code") && (
                      <InputError error={error} />
                    )}
                     
                </div>
              </div>
              <div class={getClassName("inputField", "column", "city")}>
                <div
                  class={
                    context.theme && context.theme.label
                      ? context.theme.label
                      : styles.label
                  }
                >
                  <Text id="address.city">City</Text>
                  {this.isMandatory() && (
                    <span class={getClassName("requiredSign")}>*</span>
                  )}
                </div>
                <div class={styles.column} style="width:100%">
                  {address.code_pays?.toUpperCase() !== 'FR' && (
                  <input
                    class={styles.input}
                    id="locality"
                    value={address.locality}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    type="text"
                  />
                )}
                {/* Afficher CommunesAjax seulement si FR */}

                {address.code_pays?.toUpperCase() === 'FR' && (
                  <CommunesAjax ref={this.setChildRef} 
                    onSelect={({ cp, nom }) => {
                        // Mise à jour adresse
                        this.setState(prev => {
                          const address = { ...prev.address, postal_code: cp, locality: nom };
                          return { address };
                        }, () => {
                          // envoie au parent
                          this.props.onAddressChange?.(this.state.address);
                        });
                      }}
                      locality={this.state.address.locality}
                  />

                )}
                  {error &&
                    error.fields.includes("locality") && (
                      <InputError error={error} />
                    )}
                </div>
              </div>
            </div>
            {/* <div class={styles.row}>
              <div
                class={
                  context.theme && context.theme.label
                    ? context.theme.label
                    : styles.label
                }
              >
                State
              </div>
              <div>
                <input
                  class={styles.input}
                  id="administrative_area_level_1"
                  value={address.administrative_area_level_1}
                />
              </div>
            </div> */}
            <div class={styles.column}>
              <div
                class={
                  context.theme && context.theme.label
                    ? context.theme.label
                    : styles.label
                }
              >
                <Text id="address.country">Country</Text>
                {this.isMandatory() && (
                  <span class={getClassName("requiredSign")}>*</span>
                )}
              </div>
              <div>
                 {/* <input
                  class={styles.input}
                  
                  value={address.country}
                  autoComplete="country"
                  onChange={this.onChange}
                />  */}
                {/* --{address.code_pays}--{address.country}-- */}
                <div class={styles.selectWrapper}>
                  <select
                    id="country"
                    class={getClassName("select")}
                    value={address.code_pays}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                  >
                    {COUNTRIES.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.name[locale] || c.name["fr"]}
                      </option>
                    ))}
                  </select>
                </div>
                {error &&
                  error.fields.includes("country") && (
                    <InputError error={error} />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      </IntlProvider>
    );
  }
}
/* eslint-enable */
export default withStyles(AutocompleteAddress, styles) //withScriptjs(withStyles(AutocompleteAddress, styles));
